__turbopack_context__.v({
  "buttonContainer": "ProductCode-module-scss-module__xUuLeW__buttonContainer",
  "examples": "ProductCode-module-scss-module__xUuLeW__examples",
  "examplesContainer": "ProductCode-module-scss-module__xUuLeW__examplesContainer",
  "examplesHeadline": "ProductCode-module-scss-module__xUuLeW__examplesHeadline",
  "examplesItem": "ProductCode-module-scss-module__xUuLeW__examplesItem",
  "examplesList": "ProductCode-module-scss-module__xUuLeW__examplesList",
  "header": "ProductCode-module-scss-module__xUuLeW__header",
  "headerText": "ProductCode-module-scss-module__xUuLeW__headerText",
  "help": "ProductCode-module-scss-module__xUuLeW__help",
  "helpCopy": "ProductCode-module-scss-module__xUuLeW__helpCopy",
  "howToFindIt": "ProductCode-module-scss-module__xUuLeW__howToFindIt",
  "inner": "ProductCode-module-scss-module__xUuLeW__inner",
  "magnifier": "ProductCode-module-scss-module__xUuLeW__magnifier",
  "root": "ProductCode-module-scss-module__xUuLeW__root",
});
